__turbopack_context__.v({
  "button": "ZealVariant-module__NU9TEG__button",
  "buttonList": "ZealVariant-module__NU9TEG__buttonList",
  "description": "ZealVariant-module__NU9TEG__description",
  "heading": "ZealVariant-module__NU9TEG__heading",
  "logo": "ZealVariant-module__NU9TEG__logo",
  "overlay": "ZealVariant-module__NU9TEG__overlay",
  "popup": "ZealVariant-module__NU9TEG__popup",
  "primaryButton": "ZealVariant-module__NU9TEG__primaryButton",
  "secondaryButton": "ZealVariant-module__NU9TEG__secondaryButton",
});
